import Vue from 'vue'
import Vuex from 'vuex'
import {allProjectIds} from "@/config";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        openGlobalDocumentIds: {},
        documentCanSubmitMaps: {},
        isInitialized: false,
        initialUserInfoLoading: false,
        userInfo: null,
        isUserManager: false,
        canAccessProjects: [],
        initError: false,
        userAuthenticated: false,
        userOnceAuthenticated: false,
        homeLastSelectedViewMode: null,
        workMode: null,
        existsUnsavedChanges: null,
        lastSelectedViewer: null,
    },
    mutations: {
        setOpenGlobalDocumentIds(state, payload) {
            Vue.set(state.openGlobalDocumentIds, payload.projectId, payload.globalDocumentIds);
        },
        setDocumentCanSubmit(state, payload) {
            const projectId = payload.projectId;
            const documentCanSubmitMaps = state.documentCanSubmitMaps;

            let v;

            if (projectId in documentCanSubmitMaps) {
                v = documentCanSubmitMaps[projectId];
                Vue.set(v, payload.globalDocumentId, payload.canSubmit);
            } else {
                v = {};
                v[payload.globalDocumentId] = payload.canSubmit;
                Vue.set(documentCanSubmitMaps, projectId, v);
            }
        },
        setInitialized(state, b) {
            state.isInitialized = b;
        },
        setInitialUserInfoLoading(state, b) {
            state.initialUserInfoLoading = b;
        },
        setUserInfo(state, ui) {
            state.userInfo = ui;
            state.isUserManager = ui && ui.is_manager;
            state.canAccessProjects = ui ? ui.access_to_all_projects ? allProjectIds : (ui.accessible_projects || []) : []
        },
        setInitError(state, b) {
            state.initError = b;
        },
        setUserAuthenticated(state, b) {
            state.userAuthenticated = b;
            if (b && !state.userOnceAuthenticated) {
                state.userOnceAuthenticated = true;
            }
        },
        setUserOnceAuthenticated(state, b) {
            state.userOnceAuthenticated = b;
        },
        setHomeLastSelectedViewMode(state, m) {
            state.homeLastSelectedViewMode = m;
        },
        setWorkMode(state, m) {
            state.workMode = m;
        },
        setExistsUnsavedChanges(state, b) {
            state.existsUnsavedChanges = b;
        },
        setLastSelectedViewer(state, v) {
            state.lastSelectedViewer = v;
        }
    },
    actions: {},
    modules: {}
})
